import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToHash from "@/components/ScrollToHash";

// Lazy load pages for code splitting
const Index = lazy(() => import("./pages/Index"));
const GuestBookPage = lazy(() => import("./pages/GuestBookPage"));
const FAQPage = lazy(() => import("./pages/FAQPage"));
const GuestGalleryPage = lazy(() => import("./pages/GuestGalleryPage"));
const InstallPage = lazy(() => import("./pages/InstallPage"));
const ProgrammePage = lazy(() => import("./pages/ProgrammePage"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

// Simple loading fallback
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="w-8 h-8 border-2 border-gold border-t-transparent rounded-full animate-spin" />
  </div>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToHash />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/guestbook" element={<GuestBookPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/guest-gallery" element={<GuestGalleryPage />} />
            <Route path="/install" element={<InstallPage />} />
            <Route path="/programme" element={<ProgrammePage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
